type CloudflareTransform = {
  variant: '2048' | '1024' | '512' | '768' | 'default' | 'full' | 'jpg' | 'optimized' | 'orig2' | 'public';
  width?: number;
  height?: number;
  quality?: number;
  format?: 'auto' | 'jpg' | 'png' | 'webp' | 'avif';
};

function isValidCloudflareImageUrl(urlString: string): boolean {
  try {
    new URL(urlString);
    if (!urlString.includes('imagedelivery.net')) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function transformCloudflareImageUrl(originalUrl: string, transform: CloudflareTransform): string {
  if (!isValidCloudflareImageUrl(originalUrl)) {
    return originalUrl;
  }

  const url = new URL(originalUrl);

  // Extract the base URL and image path
  const baseUrl = url.origin;
  const imagePath = url.pathname.split('/').slice(0, -1).join('/');

  // Construct the new URL with the requested variant and transformations
  const transformedUrl = new URL(`${baseUrl}${imagePath}/${transform.variant}`);

  // Add any additional transformations
  if (transform.width || transform.height || transform.quality || transform.format) {
    const searchParams = new URLSearchParams();
    if (transform.width) searchParams.append('width', transform.width.toString());
    if (transform.height) searchParams.append('height', transform.height.toString());
    if (transform.quality) searchParams.append('quality', transform.quality.toString());
    if (transform.format) searchParams.append('format', transform.format);
    transformedUrl.search = searchParams.toString();
  }

  return transformedUrl.toString();
}
